/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/admin/v3/postbacks/user-settings": {
    patch: operations["PatchApiAdminV3PostbacksUserSettings"];
  };
  "/api/v3/postbacks": {
    /** Postbacks list */
    get: operations["GetApiV3Postbacks"];
    /** Create postback */
    post: operations["PostApiV3Postbacks"];
  };
  "/api/v3/postbacks/user-settings": {
    get: operations["GetApiV3PostbacksUserSettings"];
  };
  "/api/v3/postbacks/{id}": {
    /** Get postback */
    get: operations["GetApiV3PostbacksId"];
    /** Delete postback */
    delete: operations["DeleteApiV3PostbacksId"];
    /** Update postback */
    patch: operations["PatchApiV3PostbacksId"];
  };
  "/api/v3/postbacks/{id}/test": {
    /** Send test postback */
    post: operations["PostApiV3PostbacksIdTest"];
  };
  "/ping": {
    get: operations["GetPing"];
  };
  "/send_test_postback": {
    /** Send test postback by User for test settings */
    post: operations["PostSendTestPostback"];
  };
}

export interface components {
  schemas: {
    Error: {
      error?: components["schemas"]["ErrorItem"];
    };
    ErrorField: {
      /** @description translation key of error */
      key?: string;
      params?: { [key: string]: string };
    };
    /**
     * @example {
     *   "common": {
     *     "key": "api_error.rate_limit",
     *     "params": {
     *       "until": 1551908007642
     *     }
     *   },
     *   "fields": {
     *     "name": {
     *       "key": "api_error.validation_is_int",
     *       "params": {
     *         "value": "whatever was passed as non int"
     *       }
     *     }
     *   }
     * }
     */
    ErrorItem: {
      _global?: components["schemas"]["ErrorField"];
      fields?: { [key: string]: components["schemas"]["ErrorField"] };
    };
    PaginatedCollection: {
      totalCount: number;
    };
    Postback: {
      advertiser_id?: number;
      aff_model?: string;
      aff_track: string;
      context: components["schemas"]["PostbackContextEnum"];
      event: components["schemas"]["PostbackEventEnum"];
      fields: components["schemas"]["PostbackField"][];
      id: number;
      name: string;
      url: string;
    };
    /** @enum {string} */
    PostbackContextEnum: "default" | "telegram";
    PostbackCreate: {
      advertiser_id?: number;
      aff_model?: string;
      aff_track: string;
      context?: components["schemas"]["PostbackContextEnum"];
      event: components["schemas"]["PostbackEventEnum"];
      fields: components["schemas"]["PostbackField"][];
      name: string;
      url: string;
    };
    /** @enum {string} */
    PostbackEventEnum:
      | "registration"
      | "deposit"
      | "first_deposit"
      | "repeat_deposit"
      | "lead"
      | "payout"
      | "deal"
      | "install";
    PostbackField: {
      alias: string;
      name: components["schemas"]["PostbackFieldEnum"];
    };
    /** @enum {string} */
    PostbackFieldEnum:
      | "click_id"
      | "aff_track"
      | "country_code"
      | "postback_name"
      | "platform"
      | "aff_model"
      | "event_id"
      | "trader_id"
      | "profit"
      | "instrument"
      | "advertiser_id"
      | "amount";
    PostbackTested: {
      /** Format: date-time */
      created: string;
      id: number;
      status: components["schemas"]["PostbackTestedStatusEnum"];
      url: string;
    };
    /** @enum {string} */
    PostbackTestedStatusEnum: "ok" | "error";
    PostbackUpdate: {
      aff_track: string;
      fields: components["schemas"]["PostbackField"][];
      name: string;
      url: string;
    };
    PostbacksCollection: components["schemas"]["PaginatedCollection"] & {
      data: components["schemas"]["Postback"][];
    };
    SendTestPostbackInternalInput: {
      postbackId: number;
    };
    SentTestPostback: {
      sentPostbackId: number;
    };
    UserSettings: {
      isEnabled: boolean;
    };
    UserSettingsInput: {
      isEnabled?: boolean;
      userId: number;
    };
  };
  parameters: {
    /** @description size of slice */
    PageSizeParam: number;
    PageSkipParam: number;
    /** @description The id of postback */
    PostbackId: number;
    PostbacksFilterByContext: components["schemas"]["PostbackContextEnum"];
    PostbacksSortBy: "id" | "name" | "event" | "url" | "aff_model";
    SortOrder: "asc" | "desc";
  };
  requestBodies: {
    SendTestPostbackInternalInput: {
      content: {
        "application/json": components["schemas"]["SendTestPostbackInternalInput"];
      };
    };
    UserSettingsInput: {
      content: {
        "application/json": components["schemas"]["UserSettingsInput"];
      };
    };
  };
}

export interface operations {
  PatchApiAdminV3PostbacksUserSettings: {
    responses: {
      /** Success */
      201: unknown;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["UserSettingsInput"];
  };
  /** Postbacks list */
  GetApiV3Postbacks: {
    parameters: {
      query: {
        skip?: components["parameters"]["PageSkipParam"];
        /** size of slice */
        first?: components["parameters"]["PageSizeParam"];
        sort?: components["parameters"]["PostbacksSortBy"];
        order?: components["parameters"]["SortOrder"];
        context?: components["parameters"]["PostbacksFilterByContext"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["PostbacksCollection"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /** Create postback */
  PostApiV3Postbacks: {
    responses: {
      /** Success */
      201: {
        content: {
          "application/json": components["schemas"]["Postback"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PostbackCreate"];
      };
    };
  };
  GetApiV3PostbacksUserSettings: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["UserSettings"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /** Get postback */
  GetApiV3PostbacksId: {
    parameters: {
      path: {
        /** The id of postback */
        id: components["parameters"]["PostbackId"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["Postback"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /** Delete postback */
  DeleteApiV3PostbacksId: {
    parameters: {
      path: {
        /** The id of postback */
        id: components["parameters"]["PostbackId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /** Update postback */
  PatchApiV3PostbacksId: {
    parameters: {
      path: {
        /** The id of postback */
        id: components["parameters"]["PostbackId"];
      };
    };
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Not found */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PostbackUpdate"];
      };
    };
  };
  /** Send test postback */
  PostApiV3PostbacksIdTest: {
    parameters: {
      path: {
        /** The id of postback */
        id: components["parameters"]["PostbackId"];
      };
    };
    responses: {
      /** Success */
      201: {
        content: {
          "application/json": components["schemas"]["PostbackTested"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unauthorized */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetPing: {
    responses: {
      /** Success */
      200: unknown;
    };
  };
  /** Send test postback by User for test settings */
  PostSendTestPostback: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["SentTestPostback"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Not found postback */
      404: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["SendTestPostbackInternalInput"];
  };
}

export interface external {}

export enum ApiPaths {
  PatchApiAdminV3PostbacksUserSettings = "/api/admin/v3/postbacks/user-settings",
  GetApiV3Postbacks = "/api/v3/postbacks",
  PostApiV3Postbacks = "/api/v3/postbacks",
  GetApiV3PostbacksUserSettings = "/api/v3/postbacks/user-settings",
  DeleteApiV3PostbacksId = "/api/v3/postbacks/:id",
  GetApiV3PostbacksId = "/api/v3/postbacks/:id",
  PatchApiV3PostbacksId = "/api/v3/postbacks/:id",
  PostApiV3PostbacksIdTest = "/api/v3/postbacks/:id/test",
  GetPing = "/ping",
  PostSendTestPostback = "/send_test_postback",
}
